import r3 from "../assets/images/r3.jpg";
import todo from "../assets/images/todo.png";
import stokveel from "../assets/images/stokveel.png";
import validator from "../assets/images/validator.png";
import art from "../assets/images/art.png";
import { useState } from "react";
import Reiq from "./projets/Reiq";
import ApiValidator from "./projets/ApiValidator";
import Stokvel from "./projets/Stokvel";
import Todo from "./projets/Todo";
import Pixel from "./projets/Pixel";

export default function Work() {

  const projects = [
    { img: r3, project: "reiq" },
    { img: validator, project: "apivalidator" },
    { img: todo, project: "todo" },
    { img: stokveel, project: "stokvel" },
    { img: art, project: "pixel" },
  ];

  const [component, setComponent] = useState(null);
  const [activeProject, setActiveProject] = useState("reiq");

  const renderComponent = () => {
    switch (component) {
      case "apivalidator":
        return <ApiValidator />;
      case "todo":
        return <Todo />;
      case "stokvel":
        return <Stokvel />;
      case "pixel":
        return <Pixel />;
      default:
        return <Reiq />;
    }
  };
  return (
    <div className=" bg-[#ece1cf] p-5 gap-5 md:p-8 grid h-auto md:h-full">
      <div className="">
        <h1 className="md:text-4xl text-lg font-bold text-[#2e2d69]">
          My projects
        </h1>
      </div>
      <div className="flex overflow-hidden w-full h-full transition-all ease-in duration-200 flex-row md:row-span-9">
        <div className="w-full h-full grid gap-8 md:gap-0 md:grid-cols-5 ">
          <div className="grid grid-flow-col h-full max-sm:auto-cols-max  md:grid-flow-row border border-gray-900 rounded-xl md:rounded-e-none md:rounded-s-xl overflow-x-auto md:overflow-x-visible md:overflow-y-auto">
            {projects.map((project) => {
              const key = project.project.toLowerCase();
              const isActive = activeProject === key;
              return (
                <div
                  className={`${isActive ? "bg-[#767676]" : "bg-[#d6b797]"} hover:bg-[#767676] transition ease-in-out duration-300 cursor-pointer flex justify-center md:justify-start flex-col md:flex-row items-center px-5 md:gap-5 sm:gap-3 gap-2`}
                  onClick={() => {
                    setActiveProject(key);
                    setComponent(key);
                  }}
                >
                  <img
                    src={project.img}
                    className="md:w-10 md:h-10 w-5 h-5 rounded-full"
                  />
                  <h1 className="md:block text-[10px] md:text-[16px] md:font-extrabold text-[#102a42] ">
                    {project.project}
                  </h1>
                </div>
              );
            })}
          </div>
          <div className="md:col-span-4 p-3 overflow-x-hidden rounded-tr-lg md:px-10 h-full rounded-xl md:rounded-s-none border overflow-y-auto  grid  border-gray-900 rounded-e-xl">
            {renderComponent()}
          </div>
        </div>
      </div>
    </div>
  );
}
